import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'dislivellopositivo'
})

export class DislivelloPositivoPipe implements PipeTransform {

     /**in base al parametro passato si setta il livello di dislivello positivo
     * @param  {number} value
     */
    transform(value: number): string {
        let distanza: string = '<i class="fas fa-sort-up" title="Dislivello Positivo"></i> ' +  (value == null ? '0' : value.toString()) + ' m';
        return distanza;
    }
}